import React from 'react';

const IconLaravel = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path fill="#FF2D20" d="M24 42L8 12h8l8 12 8-12h8L24 42z" />
    <path fill="#FF2D20" d="M24 30l-6-10h4l4 6 4-6h4l-6 10h-4z" opacity="0.9" />
  </svg>
);

export default IconLaravel;
